// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__uULlt","mensagem":"style_mensagem__V-Gk7","error":"style_error__AaXP8"};